import { Component, OnInit, Inject, ChangeDetectorRef, ViewChild } from '@angular/core';
import { MatDialog, MatDialogRef, MAT_DIALOG_DATA, MatChipInputEvent} from '@angular/material';
import { COMMA, ENTER } from '@angular/cdk/keycodes';
import { InsuranceService } from '../../services/insurance/insurance.service';
import 'rxjs/add/operator/map';
import { Http, Headers, RequestOptions, Response } from '@angular/http';
import { Router, ActivatedRoute } from '@angular/router';
import { UploadService } from '../../services/upload/upload.service';
import { FormControl, FormGroup, Validators, FormBuilder } from '@angular/forms';
import { SearchTermservice } from '../../services/search/search-service.service';
import { documentInformation } from '../../model/document.model';
import { Region } from '../../model/region.model'
import { ChangeLogService } from '../../services/change_log/change-log.service';
import * as momenttimezone from 'moment-timezone';
import { GoogleAnalyticsService } from '../../services/google_analytics/google-analytics.service';
import { GetDocStatusByRole } from '../../../shared/globalService';
import { empty } from 'rxjs/observable/empty';

@Component({
  selector: 'app-agent-insurance-dialog',
  templateUrl: './agent-insurance-dialog.component.html',
  styleUrls: ['./agent-insurance-dialog.component.css']
})
export class AgentInsuranceDialogComponent implements OnInit {
  submitSuccess;
  message;
  aidetails;
  data: any = {
    exempt_check: false,
    docid: '',
    MasterVendorId: '',
    VendorInsuranceId: '',
    policynum: '',
    phonenum: '',
    contact: '',
    insurancevendor: '',
    address1: '',
    address2: '',
    city: '',
    state: '',
    postalcode: '',
    expiration: '',
    insuranceExpiration : Date,
    autoexpiration: Date,
    general_liability_occurance: '',
    general_liability_aggregate: '',
    wrongfull_liability_limit: '',
    workmas_comp_liability_limit: '',
    onhookormotor_liability_limit: '',
    auto_liability_limit: '',
    garage_liability_limit: '',
    cancellation_notice: '',
    storage_location: false,
    par_as_insured: false,
    documentlink: '',
    documentStatus: '',
    fileUpdated: false
  };
  documentInfo: documentInformation = new documentInformation();
  date;
  states = [];
  iserror: boolean;
  errmsg: string;
  ziperror: boolean;
  errmessage: string;
  MasterVendorId: string;
  response = [];
  minDate = new Date();
  externalURL: any;
  onChangeFile: boolean = false;
  isFileChanged: boolean = false;
  onChangeFileName: string;
  updateFile: boolean = false;
  chooseFile: boolean = false;
  selectedRegion: any;
  errorMsg: boolean = false;
  isdatewrong: boolean;
  datewrongmsg: string;
  statesList: any = [];
  logFormData: any;
  loginId: any;
  errorMessage: String = '';
  errorEnable: boolean = false;
  vendorName;
  uploadFlag: boolean = true;
  matSpinner: boolean = false;
  signedUrl;
  newFilePath;
  newFilePath1;
  firstName;
  lastName;
  checked = false;
  placeholder = "Select a State"
  previousValues: any = [];
  previousFileName: any;

  visible = true;
  selectable = true;
  removable = true;
  addOnBlur = true;
  readonly separatorKeysCodes: number[] = [ENTER, COMMA];
  insurancecarriers: any = [];
  inscflag: boolean = false;

  @ViewChild('chipList') chipList;


  add(event: MatChipInputEvent): void {
    const input = event.input;
    const value = event.value;

    // Add our Insurance carriers
    if ((value || '').trim()) {
      Array.from(new Set(this.insurancecarriers));
      this.insurancecarriers.push(value.trim());

    }

    // Reset the input value
    if (input) {
      input.value = '';
    }

    if (this.insurancecarriers.length > 6) {
      this.inscflag = true;
      this.chipList.errorState = true;
    }
  }

  remove(insurancecarrier): void {
    const index = this.insurancecarriers.indexOf(insurancecarrier);


    if (index >= 0) {
      this.insurancecarriers.splice(index, 1);
    }

    if (this.insurancecarriers.length > 6) {
      this.chipList.errorState = true;
      this.inscflag = true;
    }
    else{
      this.chipList.errorState = false;
      this.inscflag = false;
    }
  }
  constructor(
    private googleAnalyticsService: GoogleAnalyticsService,
    private changelogservice: ChangeLogService,
    private uploadService: UploadService,
    private http: Http, private router: Router,
    private insuranceservice: InsuranceService,
    public dialogRef: MatDialogRef<AgentInsuranceDialogComponent>,
    @Inject(MAT_DIALOG_DATA) public agentdata: any,
    public search: SearchTermservice,
    public ref: ChangeDetectorRef,
    public fb: FormBuilder,
    private getDocStatusByRole: GetDocStatusByRole) {
    this.date = new FormControl(new Date());
  }

  placeholderChange() {
    this.placeholder = "State";
  }

  onNoClick(): void {
    this.dialogRef.close();
  }

  ngOnInit() {
    
    this.loginId = localStorage.getItem('loginID');
    this.MasterVendorId = localStorage.getItem("AgentId");
    this.vendorName = localStorage.getItem('AgentName');
    this.firstName = localStorage.getItem("username");
    this.lastName = localStorage.getItem('Lastname');
    this.search.getListOfStates().subscribe(res => {
      this.statesList = res.States;
      this.statesList.forEach(state => {
        this.states.push(state.Code);
      });
    }, error => {
      this.errorEnable = true;
      this.errorMessage = "All States: " + error;
      this.scrollTop();
    })

    this.data.MasterVendorId = this.agentdata.data.MasterVendorId;
    this.data.VendorInsuranceId = this.agentdata.data.VendorInsuranceId;
    this.data.documenttype = this.agentdata.data.DocumentType;
    this.data.docid = this.agentdata.data._id;
    this.data.documentcode = this.agentdata.data.DocumentTypeCode;
    this.data.fileName = this.agentdata.data.FileName;
    if (this.agentdata.type === 'update') {
      this.chooseFile = false;
      this.updateFile = true;
      this.onChangeFile = true;
      this.insuranceservice.insdetails(this.data.docid).subscribe(res => {
        localStorage.setItem('old', JSON.stringify(res.Documents[0]));
        this.data.exempt_check = res.Documents[0].WorksmanExemptCheck ? true : false;
        this.data.expiration = res.Documents[0].ExpirationDate;
        this.data.documentlink = res.Documents[0].DocumentLink;
        this.insurancecarriers = res.Documents[0].InsuranceCarrier;
        this.data.insurancevendor = res.Documents[0].InsuranceVendor;
        this.data.city = res.Documents[0].City;
        this.data.policynum = res.Documents[0].PolicyNumber;
        this.data.phonenum = res.Documents[0].PhoneNumber;
        this.data.contact = res.Documents[0].Contact;
        this.data.address1 = res.Documents[0].Address1;
        this.data.address2 = res.Documents[0].Address2;
        this.data.state = res.Documents[0].State;
        this.placeholder = res.Documents[0].State ? 'State' : 'Select a State';
        this.data.postalcode = res.Documents[0].PostalCode;//;
        this.data.insuranceExpiration = res.Documents[0].InsuranceExpiration;
        this.data.autoexpiration = res.Documents[0].AutoLiabilityExpirationDate;
        this.data.generalliabilityoccurance = res.Documents[0].GeneralLiabilityOccurance;
        this.data.generalliabilityaggregate = res.Documents[0].GeneralLiabilityAggregate;;
        this.data.wrongfullliabilitylimit = res.Documents[0].WrongfulLiabilityLimit;
        this.data.workmascompliabilitylimit = res.Documents[0].WorkmansCompLiabilityLimit;
        this.data.onhookormotorliabilitylimit = res.Documents[0].OnhookormotorLiabilityLimit;
        this.data.autoliabilitylimit = res.Documents[0].AutoLiabilityLimit;
        this.data.garageliabilitylimit = res.Documents[0].GarageLiabilityLimit;
        if (res.Documents[0].InsuranceCarrier === null || res.Documents[0].InsuranceCarrier === undefined || res.Documents[0].InsuranceCarrier === empty) {
          this.insurancecarriers = [];
        }
        if (res.Documents[0].CancellationNotice === 'Y') {
          this.data.cancellationnotice = true;
        } else {
          this.data.cancellationnotice = false;
        }
        if (res.Documents[0].StorageLocation === 'Y') {
          this.data.storagelocation = true;
        } else {
          this.data.storagelocation = false;
        }
        if (res.Documents[0].ParAsInsured === 'Y') {
          this.data.parasinsured = true;
        } else {
          this.data.parasinsured = false;
        }
      }, error => {
        this.errorEnable = true;
        this.errorMessage = "Insurance details: " + error;
        this.scrollTop();
      });
    } else if (this.agentdata.type === 'create') {
      this.chooseFile = true;
      this.updateFile = false;
    }
  }

  scrollTop() {
    const element = document.getElementById('scrollToTop');
    element.scrollIntoView();
  }

  clear() {
    this.dialogRef.close();
  }

  checkType() {
  }

  setFileData(docInfo) {
    this.googleAnalyticsService.emitEvent(this.firstName + ' ' + this.lastName, "Upload a" + ' ' + this.agentdata.data.DocumentTypeName + ' ' + 'Document', this.vendorName, 10);
    setTimeout(() => {
      this.documentInfo = docInfo;
      this.data.fileName = this.documentInfo.fileName;
      this.ref.markForCheck();
      this.ref.detectChanges()
    }, 100);
    // will be used to upload the file into amazon
    this.isFileChanged = true;
  }

  saveDocument() {
    this.matSpinner = true;
    this.uploadFlag = false;
    if (this.isFileChanged === false && this.agentdata.type === 'update') {
      this.externalURL = this.data.DocumentLink;
      this.submit();
    }
    else {
      let today = new Date();
      const estTimeZone = 'America/New_York';
      let uploadTimeZone = momenttimezone(today).tz(estTimeZone).format();
      uploadTimeZone = uploadTimeZone.replace(/[^a-zA-Z0-9]/g, '');
      var filePath = "Agent/" + this.data.MasterVendorId + "/insuranceDocs/" + this.data.documentcode + "/";
      this.data.fileName = this.documentInfo.fileName;
      let fileNameWithoutExt = this.documentInfo.fileName.substring(0, this.documentInfo.fileName.lastIndexOf('.'));
      let fileNameExt = this.documentInfo.fileName.substring(this.documentInfo.fileName.lastIndexOf('.') + 1, this.documentInfo.fileName.length);
      this.documentInfo.fileInput.append('url', filePath + fileNameWithoutExt + '_' + uploadTimeZone + '.' + fileNameExt);
      this.newFilePath1 = filePath + fileNameWithoutExt + '_' + uploadTimeZone + '.' + fileNameExt;
      let body = {
        "newFilePath": this.newFilePath1,
        "vendor_id": this.MasterVendorId
      }
      this.uploadService.getSignedURL(body).subscribe((res) => {
        this.signedUrl = res.Info;
        this.uploadService.uploadDocumentWithSignedUrl(this.documentInfo.file, this.signedUrl).subscribe((obj) => {
          this.externalURL = this.newFilePath1;
          this.data.documentlink = this.externalURL;
          this.submit();
        });
      }, error => {
        this.errorMessage = "File upload: " + error;
        this.submitSuccess = true;
        this.scrollTop();
        this.matSpinner = false;
      });
    }
  }

  submit() {
    this.submitSuccess = false;
    this.data.documentStatus = this.getDocStatusByRole.docStatusByRole();
    this.logFormData = {
      "document_type": this.agentdata.data.DocumentType,
      "document_category": this.agentdata.data.DocumentCategory,
      "transaction_type": "Add",
      "vendor_id": this.MasterVendorId,
      "modified_by": this.loginId
    }
    if (this.agentdata.type === 'create') {
      this.insuranceservice.createNewAgentInsurance(this.data, this.insurancecarriers).subscribe(res => {
        this.googleAnalyticsService.emitEvent(this.firstName + ' ' + this.lastName, "Create a" + ' ' + this.agentdata.data.DocumentTypeName + ' ' + 'Document', this.vendorName, 10);
        this.submitSuccess = true;
        this.message = 'Insurance Document Created Successfully';
        this.insuranceservice.load.next('success')
        this.dialogRef.close();
        this.changelogservice.sendLogs(this.logFormData).subscribe(res => { }, err => {
          this.errorMessage = err;
          this.errorEnable = true;
          this.matSpinner = false;
          this.scrollTop();
        });
      }, error => {
        this.errorMessage = "Create vendor insurance: " + error;
        this.errorEnable = true;
        this.matSpinner = false;
        this.scrollTop();
        this.submitSuccess = true;
        this.insuranceservice.load.next('fail')
      })
    } else {
      this.data.fileUpdated = this.isFileChanged;
      this.insuranceservice.updateAgentInsurance(this.data, this.insurancecarriers).subscribe(res => {
        this.googleAnalyticsService.emitEvent(this.firstName + ' ' + this.lastName, "Update a" + ' ' + this.agentdata.data.DocumentTypeName + ' ' + 'Document', this.vendorName, 10);
        this.submitSuccess = true;
        this.message = 'Agent Insurance Information Updated';
        this.insuranceservice.load.next('success')
        this.dialogRef.close();
        if (this.logFormData.transaction_type == "Add") {
          this.logFormData.transaction_type = "Edit";
          this.logFormData.document_category = this.agentdata.category;
          this.logFormData.vendor_id = this.agentdata.data.MasterVendorId;
          this.previousValues = localStorage.getItem('old');
          this.previousFileName = localStorage.getItem('oldVendorInsuranceFileName');
          this.logFormData.previous_fields = JSON.parse(this.previousValues);
          this.logFormData.collection_name = "vendor_insurance_details";
          this.logFormData.previous_fields.FileName = JSON.parse(this.previousFileName);
          this.changelogservice.sendLogs(this.logFormData).subscribe(res => { }, err => {
            this.errorMessage = err;
            this.errorEnable = true;
            this.matSpinner = false;
            this.scrollTop();
          });
        }
      }, error => {
        this.errorMessage = "Update Vendor insurance" + error;
        this.errorEnable = true;
        this.matSpinner = false;
        this.scrollTop();
        this.submitSuccess = true;
        this.insuranceservice.load.next('fail');
      });
    }
  }
}



// WEBPACK FOOTER //
// ./src/app/components/agent-insurance-dialog/agent-insurance-dialog.component.ts